import {Component} from "../../gvf/js/component";

export class ModuleComponent extends Component{

}